import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';
import defalut from '@static/image/default-bg.png';
import Color from '@/tool/color';
import { GoLeftIcon } from '@/styled/icon';
import { cloneDeep, isEmpty, round } from 'lodash';
import moDemandPdf from '../store';
import moIndex from '../../store';

interface IProps {
  list: any;
  index: number;
}
interface IState {}

const CompanyRankChart = (props: IProps, state: IState) => {
  const { isMock } = moIndex;
  const { companyRankList } = moDemandPdf;
  const { list, index } = props;
  const getResult = useMemo(() => {
    let list: any = [];
    if (!isEmpty(companyRankList?.data)) {
      const res = cloneDeep(companyRankList?.data);
      res.sort((a: any, b: any) => b.amount_change - a.amount_change);
      list = res || [];
    }
    return list;
  }, [companyRankList]);

  useEffect(() => {}, []);

  return (
    <section
      className="company-rank-svg-warp"
      style={{
        backgroundImage: isMock ?
          'url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)' :
          '',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
      }}>
      {list?.map((res: any, r: any) => {
        return (
          <section className="items" key={r}>
            <section className="svg-left">
              <b
                style={{
                  backgroundImage: `url(${res.company_logo || defalut})`,
                }}></b>
              <span
                style={{
                  color: index * 7 + r + 1 >= 3 ? Color.c87 : Color.red,
                }}>
                TOP.{index * 7 + r + 1}
              </span>
            </section>
            <section className="svg-mid">
              <p>{res.company_name}</p>
              <p
                style={{
                  color:
                    res.amount_change >= 0 ? Color.secondary : Color.success,
                }}>{`较上期：${round(res.amount_change * 100, 1)}%`}</p>
              <p>
                <b
                  style={{
                    width: `${
                      (Math.abs(res.amount_change) /
                          getResult[0].amount_change) *
                        100
                    }%`,
                    background:res.amount_change >= 0 ? 'linear-gradient(270deg, #fad961 0%, #f76b1c 100%)' : 'linear-gradient(90deg, rgba(0,195,137,0.9) 0%, rgba(0,227,190,0.5) 100%)',
                  }}></b>
              </p>
            </section>
            <section className="svg-right">
              <p></p>
              <p>{res.amount.toLocaleString()}</p>
            </section>
          </section>
        );
      })}
    </section>
  );
};

export default observer(CompanyRankChart);
